import useTranslation from '~/hooks/useTranslation';
import savingIndicatorStyles from '~/styles/saving-indicator.module.css';
import utilStyles from '~/styles/utils.module.css';
import Spinner from './Spinner';

export default function SavingIndicator() {
  const translate = useTranslation();

  return (
    <div className={savingIndicatorStyles.savingIndicator}>
      <Spinner className={savingIndicatorStyles.spinner} />
      <span className={utilStyles.srOnly}>{translate('bookingFlow.saving')}</span>
    </div>
  );
}
